import React, { useContext, useEffect, useRef, useState } from "react";
import Navbar from "../../../../components/Navbar/Navbar";
import bg from "../../../../assets/images/background.png";
import "./AppInventory.scss";
import { useQuery } from "../../../../helper/useQuery";
import { useHistory, useLocation } from "react-router-dom";
import Searchbar from "../../../../components/Searchbar/Searchbar";
import Button from "../../../../components/Button/Button";
import Dropdown from "../../../../components/Dropdown/Dropdown";
import CreateLicense from "../../Apps/AppLicense/CreateLicense";
import { axiosApiInstance } from "../../../../helper/request";
import Scroller from "../../../../components/Scroller/ScrollBar";
import AppLicenseList from "../../Apps/AppLicense/AppLicenseList";
import { useDebouncedEffect } from "../../../../helper/useDebounce";
import AnimatedModal from "../../../../components/Modal/AnimatedModal";
import Loading from "../../../../components/Loading/Loading";
import { encryptStorage } from "../../../../helper/storage";
import EditPricing from "../../Apps/AppLicense/EditPricing";
import AssignUserMgf from "../../Apps/AppLicense/AssignUserMgf";
import EditMarkup from "../../Apps/AppLicense/EditMarkup";
import { ThemeContext } from "../../../../helper/context";
import AssignInventory from "../../Inventory/AssignInventory";
import AssignInventoryModal from "../../Inventory/Component/AssignInventoryModal/AssignInventoryModal";
import AppDevice from "../Component/AppDevice/AppDevice";
import SpecialLicense from "../Component/SpecialLicense/SpecialLicense";
import SelectLicense from "../../../shared/Device/SelectLicense";
import CreatedLicenseCard from "../../Inventory/Component/CreatedLicenseCard/CreatedLicenseCard";
let attributeName = [];
let Role = [];
let removeMfgData = [];
let usersUserName = [];
let pricing_details = [];
let userFlag = false;
let currentIndex = 0;
let flag = false;
let changePage = 1;
let license_name = "";
let license_id = "";
let msg = {
  type: "alert",
  header: "Error",
  errorText: "Something Went Wrong",
};

export default function AppLicense() {
  const query = useQuery();
  const location = useLocation();
  const scrollbar = useRef(null);
  const license_options = ["Standard License", "Special License"];
  let app_name = query.get("app_name") || "";
  const [IsLoading, setIsLoading] = useState(true);
  const [assignModal, setassignModal] = useState(false);
  const [MarkupModal, setMarkupModal] = useState(false);
  const [UpdatedMarkup, setUpdatedMarkup] = useState([]);
  const [ShowAlert, setShowAlert] = useState(false);
  const [Licenselist, setLicenselist] = useState([]);
  const [specialLicenseList, setSpecialLicenseList] = useState([]);
  const [mfrDetails, setmfrDetails] = useState([]);
  const [TotalRestrictedUsers, setTotalRestrictedUsers] = useState(0);
  const [LicenseSearchText, setLicenseSearchText] = useState(undefined);
  const [Type, setType] = useState("");
  const [TotalPages, setTotalPages] = useState(0);
  const [LicenseType, setLicenseType] = useState("Standard License");
  const [License, setLicense] = useState([]);
  const [specialAttributeData, setSpecialAttributeData] = useState([]);
  const [CreateLicenseModal, setCreateLicenseModal] = useState(false);
  const [createSpecialLicenseModal, setCreateSpecialLicenseModal] =
    useState(false);
  const [EditLicenseModal, setEditLicenseModal] = useState(false);
  const [EditLicense, setEditLicense] = useState([]);
  const [assignSpecialMfg, setAssignSpecialMfg] = useState(false);
  const [focusCount, setFocusCount] = useState(0);
  const [licenseName, setLicenseName] = useState("");
  const [remainingCount, setRemainingCount] = useState(0);
  const [assignDevice, setAssignDevice] = useState(false);
  const [assignType, setAssignType] = useState("");

  const themeContext = useContext(ThemeContext);
  const history = useHistory();

  useDebouncedEffect(
    () => {
      changePage = 1;
      fetchInventory(1);
    },
    [LicenseSearchText],
    1000
  );

  useEffect(() => {
    let dataa = encryptStorage.getItem("UID").roles;
    Role = dataa;
  }, []);
  // const clearSearchStates = () => {
  //   setLicenselist([]);
  // };
  const fetchInventory = (page, data) => {
    setIsLoading(true);
    let url = `inventory/role?license_type=app&app_name=${app_name}&page=${page}&items=10`;
    setLicenseType("Special License");
    if (LicenseSearchText !== undefined) {
      url = `inventory/role?license_type=app&app_name=${app_name}&licensename=${LicenseSearchText}&page=${page}&items=10`;
    }
    // if (
    //   themeContext.Role.all.includes("user") ||
    //   themeContext.Role.all.includes("manufacturer")
    // ) {
    //   url = `inventory/inventory/role?license_type=app&app_name=${app_name}&page=${page}&items=10`;
    //   setLicenseType("Special License");
    // }

    axiosApiInstance
      .get(url)
      .then((res) => {
        flag = false;
        let arr = page === 1 ? [] : [...Licenselist];
        setTotalPages(res.data.total_count);
        for (let i = 0; i < res.data.details.length; i++) {
          arr.push(res.data.details[i]);
        }
        setTimeout(() => {
          setIsLoading(false); //seeting loader false insode set timeout because data is being delayed while showing in FE
          setLicenselist([...arr]);
        }, 1000);
      })
      .catch((err) => {})
      .finally(() => {
        // setIsLoading(false);
        setLicenselist([]);

        page === 1 && scrollbar.current.scrollTop(0);
      });
  };

  const getMarkup = (name) => {
    axiosApiInstance
      .get("license/fetch/license?licensename=" + name)
      .then((res) => {
        setUpdatedMarkup([...res.data.details.pricing_details]);
      })
      .catch((err) => {});
  };

  const handleScroll = () => {
    if (scrollbar.current.getValues().top >= 0.95) {
      if (changePage <= Math.floor(TotalPages / 10) && !flag) {
        flag = true;
        changePage += 1;
        fetchInventory(changePage);
      }
    }
  };

  const getAttributes = () => {
    setIsLoading(true);
    axiosApiInstance
      .get("inventory/created/recent?license_type=app")
      .then((res) => {
        setLicense([...res.data.details.pricing_details]);
        // currentAtrLength = res.data.details.pricing_details.length;
        for (let i = 0; i < res.data.details.pricing_details.length; i++) {
          attributeName.push(
            res.data.details.pricing_details[i].attribute_name
          );
        }
      })
      .catch((err) => {})
      .then(() => {
        setIsLoading(false);
      });
  };
  const getSpecialAttributeName = () => {
    // setLoadingScreen(true)
    axiosApiInstance
      .get("inventory/created/recent?license_type=app")
      .then((res) => {
        let data = [];
        Object.keys(res.data.details).map((key) => {
          data.push({
            Name: key,
            Quantity: res.data.details[key],
          });
        });
        setSpecialAttributeData(data);
        // attributeDataArr.push(data.map((item) => item.Name));
      })
      .catch((err) => {})
      .finally(() => {
        // setLoadingScreen(false)
      });
  };

  const enableDisableLicense = (value, index) => {
    setIsLoading(true);
    axiosApiInstance
      .post("license/show/license", {
        license_id: Licenselist[index].license_id,
        show_to_user: value,
      })
      .then((res) => {
        if (value === true) {
          msg.errorText = "Successfully Enabled";
          msg.header = "Success";
          msg.type = "success";
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
        } else {
          msg.errorText = "Successfully Disabled";
          msg.header = "Success";
          msg.type = "success";
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
        }
      })
      .catch((err) => {
        msg.errorText = "Something went wrong";
        msg.header = "Error";
        msg.type = "alert";
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
      })
      .finally(() => {
        // fetchInventory(1);
        setIsLoading(false);
      });
  };

  const renderNoSearchBar = () => {
    return (
      <>
        <div className="filtered_data_subwrapper">
          <div className="addver_header_wrapper">
            <div className="addver_header_wrapper_lhs">
              <img className="addedver_appimg" src={location.state.img}></img>
              <h4 className="appver_appname">{app_name}</h4>
            </div>
            <div
              style={{ display: "flex", gap: "1vw", alignItems: "center" }}
              className="filter_btns"
            >
              {/* <div className="searchbar_filterby_wrapper">
              <Searchbar
                placeholder="Search by license name"
                handleSearch={(e) => {
                  // changePage=1;
                  setLicenseSearchText(e.target.value);
                }}
                autoFocus={true}
                value={LicenseSearchText}
              />
            </div> */}
            </div>
          </div>
        </div>

        <div className="no_plan">
          {emptyLicenseIcon()}
          <p className="no_plan_label"> No license found</p>
          {Role.includes("superadmin") && (
            <p
              onClick={() => {
                LicenseType === "Standard License"
                  ? setCreateLicenseModal(true)
                  : setCreateSpecialLicenseModal(true);
              }}
              className="create_plan_label"
            >
              Create License
            </p>
          )}
        </div>
      </>
    );
  };
  const renderWithSearchBar = () => {
    return (
      <div className="filtered_data_subwrapper">
        <div className="addver_header_wrapper">
          <div className="addver_header_wrapper_lhs">
            <img className="addedver_appimg" src={location.state.img}></img>
            <h4 className="appver_appname">{app_name}</h4>
          </div>
          <div
            style={{ display: "flex", gap: "1vw", alignItems: "center" }}
            className="filter_btns"
          >
            {Role.includes("superadmin") &&
              themeContext.Role.current === "manufacturer" && (
                <Dropdown
                  id={"license_options"}
                  style={{ width: "10vw", height: "2vw" }}
                  defaultText={license_options[0]}
                  optionsList={license_options}
                  handleOption={(data) => {
                    setLicenseType(data);
                    fetchInventory(1, data);
                  }}
                />
              )}
            {Role.includes("superadmin") && (
              <Button
                style={{ width: "12vw", padding: "0.2vw" }}
                name="Create License"
                onClick={() => {
                  LicenseType === "Standard License"
                    ? setCreateLicenseModal(true)
                    : setCreateSpecialLicenseModal(true);
                  LicenseType === "Standard License"
                    ? getAttributes()
                    : getSpecialAttributeName();
                }}
              />
            )}

            <div className="searchbar_filterby_wrapper">
              <Searchbar
                placeholder="Search by license name"
                handleSearch={(e) => {
                  // changePage=1;
                  setLicenseSearchText(e.target.value);
                }}
                autoFocus={true}
                value={LicenseSearchText}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="_app_license_wrapper_">
      {console.log(remainingCount, "remainingCount")}
      <Navbar sidenav>
        <div className="app_license_body">
          <img src={bg} className="profile_bg" />
          <div className="body_content">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h1>Added App Inventory</h1>
              <p
                className="goBack"
                onClick={() => {
                  themeContext.Role.current === "user"
                    ? history.push("/apps/serial/" + query.get("serial_number"))
                    : history.push("/apps");
                }}
              >
                Go Back
              </p>
            </div>
            <div className="app_license_data">
              <>
                {Licenselist.length === 0 ? (
                  LicenseSearchText === undefined ? (
                    Licenselist.length === 0 && renderNoSearchBar()
                  ) : (
                    <>
                      {renderWithSearchBar()}
                      <div className="no_plan">
                        {emptyLicenseIcon()}
                        <p className="no_plan_label"> No license found</p>
                      </div>
                    </>
                  )
                ) : (
                  <>
                    {renderWithSearchBar()}
                    <Scroller
                      autoHeightMax="47vh"
                      verticalStyle={{
                        width: "0.3vw",
                        marginLeft: "0vw",
                        backgroundColor: "#283e92",
                      }}
                      ref={scrollbar}
                      onScroll={handleScroll}
                    >
                      {LicenseType === "Special License" && (
                        <div className="special_license_list_container">
                          {Licenselist.map((item, index) => {
                            {
                              console.log(item.total_count, "item.total_count");
                            }

                            return (
                              <CreatedLicenseCard
                                assignClick={() => {
                                  setRemainingCount(item.total_count);
                                  setFocusCount(item.total_count);
                                  setLicenseName(item.license_name)
                                }}
                                setAssignChildMfg={setAssignSpecialMfg}
                                licenseName={item?.license_name}
                                licenseDuration={item?.license_duration}
                                licenseDetails={item?.license_details}
                                licenseQuantity={item?.total_count}
                                setAssignLicenseName={item.license_name}
                                msg={msg}
                                setShowAlert={setShowAlert}
                                setAssignType={setAssignType}
                                LicenseType={LicenseType}
                              />
                              // <SpecialLicense
                              //   key={item.license_name + "idx"}
                              //   name={item.license_name}
                              //     assignSpecailMfg={() => {
                              //     setAssignSpecialMfg(true);
                              //     setLicenseName(item.license_name);
                              //     setRemainingCount(item.total_count);
                              //     setFocusCount(item.total_count);
                              //   }}
                              //   Role={Role}
                              //   setAssignDevice={setAssignDevice}
                              //   LicenseType={LicenseType}
                              //   count={item.total_count}
                              //   duration={item.license_duration}
                              //   assignDevice={() => setAssignDevice(true)}
                              // />
                            );
                          })}
                        </div>
                      )}
                    </Scroller>
                  </>
                )}
              </>
            </div>
          </div>
        </div>
      </Navbar>
      <CreateLicense
        app_name={app_name}
        CreateLicenseModal={CreateLicenseModal}
        setCreateLicenseModal={setCreateLicenseModal}
        License={License}
        setLicense={setLicense}
        attributeName={attributeName}
        fetchInventory={fetchInventory}
      />
      {/* <EditPricing
        EditLicenseModal={EditLicenseModal}
        setEditLicenseModal={setEditLicenseModal}
        license_name={license_name}
        EditLicense={EditLicense}
        setEditLicense={setEditLicense}
        postEditLicense={postEditLicense}
      /> */}
      {/* <AssignUserMgf
        assignModal={assignModal}
        setassignModal={setassignModal}
        Type={Type}
        mfrDetails={mfrDetails}
        setmfrDetails={setmfrDetails}
        usersUserName={usersUserName}
        removeMfgData={removeMfgData}
        TotalRestrictedUsers={TotalRestrictedUsers}
        userFlag={userFlag}
        license_name={license_name}
        getMfgNames={getMfgNames}
        license_id={license_id}
        pricing_details={pricing_details}
      /> */}
      {/* <EditMarkup
        MarkupModal={MarkupModal}
        setMarkupModal={setMarkupModal}
        license_name={license_name}
        UpdatedMarkup={UpdatedMarkup}
        setUpdatedMarkup={setUpdatedMarkup}
        fetchInventory={fetchInventory}
      /> */}
      <AssignInventory
        Attributedata={specialAttributeData}
        setAttributeData={setSpecialAttributeData}
        createLicenseOpen={createSpecialLicenseModal}
        setCreateLicenseCard={setCreateSpecialLicenseModal}
        getCreatedLicense={fetchInventory}
        msg={msg}
        ShowAlert={ShowAlert}
        setShowAlert={setShowAlert}
        type={LicenseType}
        licenseName={licenseName}
      />
      {/* <AnimatedModal modalOpen={assignDevice} className="special_licence_modal">
        <AppDevice setAssignDevice={setAssignDevice} className />
      </AnimatedModal> */}
      <SelectLicense
        FetchLicense={assignDevice}
        setFetchLicense={setAssignDevice}
      />
      <AnimatedModal
        modalOpen={assignSpecialMfg}
        className="special_licence_modal"
      >
        <AssignInventoryModal
          licenseName={licenseName}
          availableCount={focusCount}
          remainingCount={remainingCount}
          setRemainingCount={setRemainingCount}
          setOpenAssignInventoryModal={setAssignSpecialMfg}
          ShowAlert={ShowAlert}
          setShowAlert={setShowAlert}
          msg={msg}
          fetchInventory={fetchInventory}
        />
      </AnimatedModal>
      <AnimatedModal
        modalOpen={ShowAlert}
        handleClose={() => {
          setShowAlert(false);
        }}
        type={msg.type}
        errorHeader={msg.header}
        errorText={msg.errorText}
        // timeout={5000}
        alwayOpen={true}
      />
      {IsLoading && <Loading type={"transparent"} text={"Loading"} />}
    </div>
  );
}

const emptyLicenseIcon = () => {
  return (
    <svg
      width={143}
      height={143}
      viewBox="0 0 143 143"
      style={{ width: "10vw", height: "10vw" }}
      fill="none"
      className="emptyLicenseIcon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_48_388)">
        <path
          d="M142.745 70.472C142.745 70.4682 142.748 70.465 142.752 70.465V70.465C142.756 70.465 142.759 70.4618 142.759 70.4579C142.757 65.5138 140.821 61.0219 137.673 57.6706C137.672 57.6689 137.672 57.6663 137.673 57.6647V57.6647C137.675 57.6632 137.675 57.6608 137.674 57.6591L111.181 23.6305C110.619 22.9079 109.754 22.4854 108.838 22.4854H32.9926C32.052 22.4854 31.1671 22.931 30.6071 23.6867L4.90465 58.3692C4.90198 58.3728 4.90235 58.3778 4.90552 58.381V58.381C4.90885 58.3843 4.90907 58.3897 4.90603 58.3933C2.51884 61.22 1.00478 64.7728 0.630719 68.6576C0.591609 69.0638 0.463432 69.4549 0.345416 69.8455C0.278361 70.0675 0.238403 70.3003 0.238403 70.5465V117.234C0.238403 118.787 1.49665 120.043 3.04683 120.043H139.953C141.506 120.043 142.762 118.788 142.762 117.234V70.5465C142.762 70.5209 142.748 70.4973 142.745 70.472ZM33.1597 29.4182C33.711 28.5957 34.636 28.1022 35.6261 28.1022H106.294C107.259 28.1022 108.163 28.5706 108.719 29.3583L124.246 51.3382C124.371 51.5149 124.241 51.7398 124.025 51.7398V51.7398H93.3085C91.6687 51.7398 90.3393 53.0692 90.3393 54.709V60.1589C90.3393 69.7184 80.3023 67.6514 77.2248 67.6514H66.0083C62.9304 67.6514 52.8938 69.7184 52.8938 60.1589V54.709C52.8938 53.0692 51.5644 51.7398 49.9246 51.7398H19.2054V51.7398C18.7739 51.7398 18.5041 51.282 18.7444 50.9236L33.1597 29.4182ZM137.145 111.457C137.145 113.097 135.816 114.426 134.176 114.426H8.8269C7.18704 114.426 5.85768 113.097 5.85768 111.457V70.5465V70.5465C5.85768 70.5018 5.87952 70.465 5.92427 70.465H5.97172C6.03734 70.465 6.09048 70.4112 6.09107 70.3456C6.15542 63.1718 12.0136 57.356 19.2051 57.356H44.474C46.0218 57.356 47.2766 58.6107 47.2766 60.1585V60.1585C47.2766 69.8276 54.6288 73.2675 66.008 73.2675H77.2244C88.6064 73.2675 95.9558 69.8276 95.9558 60.1585V60.1585C95.9558 58.6107 97.2106 57.356 98.7584 57.356H124.03C127.644 57.356 130.922 58.8246 133.297 61.1977L133.303 61.2033C135.674 63.5742 137.139 66.8449 137.142 70.4551C137.142 70.4605 137.146 70.465 137.152 70.465V70.465C137.157 70.465 137.162 70.4694 137.161 70.4748C137.158 70.499 137.145 70.5215 137.145 70.5465L137.145 111.457Z"
          fill="#367BC0"
          fillOpacity={0.5}
        />
      </g>
      <defs>
        <clipPath id="clip0_48_388">
          <rect
            width={142.523}
            height={142.523}
            fill="white"
            transform="translate(0.238281)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
